<svg
  class="odontograma-svg"
  [attr.viewBox]="'0 0 ' + viewBoxWidth + ' ' + viewBoxHeight"
  preserveAspectRatio="xMidYMid meet"
  xmlns="http://www.w3.org/2000/svg"
>
  <g *ngFor="let d of dientes; trackBy: trackByFdi" [attr.transform]="'translate(' + d.x + ',' + d.y + ')'">
    <polygon
      points="0,0 20,0 15,5 5,5"
      [attr.fill]="d.zonas.top.fill"
      class="zona"
      [class.clickable]="mode === 'edit'"
      (click)="onZoneClick($event, d, 'top')"
    />
    <polygon
      points="5,15 15,15 20,20 0,20"
      [attr.fill]="d.zonas.bottom.fill"
      class="zona"
      [class.clickable]="mode === 'edit'"
      (click)="onZoneClick($event, d, 'bottom')"
    />
    <polygon
      points="0,0 5,5 5,15 0,20"
      [attr.fill]="d.zonas.left.fill"
      class="zona"
      [class.clickable]="mode === 'edit'"
      (click)="onZoneClick($event, d, 'left')"
    />
    <polygon
      points="15,5 20,0 20,20 15,15"
      [attr.fill]="d.zonas.right.fill"
      class="zona"
      [class.clickable]="mode === 'edit'"
      (click)="onZoneClick($event, d, 'right')"
    />
    <polygon
      points="5,5 15,5 15,15 5,15"
      [attr.fill]="d.zonas.center.fill"
      class="zona"
      [class.clickable]="mode === 'edit'"
      (click)="onZoneClick($event, d, 'center')"
    />

    <ng-container [ngSwitch]="d.toothOverlay">
      <g *ngSwitchCase="'X'" stroke="#c62828" stroke-width="2" pointer-events="none">
        <line x1="0" y1="0" x2="20" y2="20" />
        <line x1="0" y1="20" x2="20" y2="0" />
      </g>
      <circle
        *ngSwitchCase="'corona'"
        cx="10" cy="10" r="11"
        fill="none" stroke="#0288d1" stroke-width="2"
        pointer-events="none"
      />
      <polygon
        *ngSwitchCase="'endodoncia'"
        points="10,2 14,18 6,18"
        fill="#6a1b9a" fill-opacity="0.7"
        pointer-events="none"
      />
      <g *ngSwitchCase="'implante'" pointer-events="none">
        <rect x="7" y="20" width="6" height="6" fill="#00695c" />
        <line x1="10" y1="0" x2="10" y2="20" stroke="#00695c" stroke-width="1.5" />
      </g>
      <g *ngSwitchCase="'pontico'" pointer-events="none">
        <path d="M0,15 L4,8 L16,8 L20,15 Z" fill="#5d4037" fill-opacity="0.5" stroke="#5d4037" stroke-width="0.8"/>
      </g>
    </ng-container>

    <text
      x="10"
      [attr.y]="28"
      text-anchor="middle"
      class="fdi-label"
      [class.clickable]="mode === 'edit'"
      (click)="onLabelClick($event, d)"
    >{{ d.fdi }}</text>
  </g>
</svg>
